<template>
  <div class="backimg"> </div>
  <LoaderOverlay />
  <div
    v-if="envBanner"
    :class="['env-banner', envBanner.class]"
    role="status"
    aria-live="polite"
  >
    {{ envBanner.label }} &mdash; API: {{ apiUrl }}
  </div>
  <div>
      <Navigation v-if="hasLaravelToken" />
      <RouterView class="router-view-content" />
      <GlobalErrorModal ref="errorModal" />
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import Oidc from 'oidc-client';
import axios from 'axios';
import Navigation from './views/components/Navigation.vue';
import LoaderOverlay from './views/components/LoaderOverlay.vue';
import GlobalErrorModal from './views/components/GlobalErrorModal.vue';
import { registerErrorHandler, showGlobalError } from './services/ErrorService';

export default {
  setup() {
      // Check if there is a Laravel token in local storage
      const hasLaravelToken = ref(localStorage.getItem('token')? true: false);
      const errorModal = ref(null);
      const apiUrl = process.env.VUE_APP_APIURL;
      const envBanner = computed(() => {
        const env = (process.env.VUE_APP_ENV || '').toLowerCase();
        if (env === 'staging') return { label: 'STAGING ENVIRONMENT', class: 'env-banner-staging' };
        if (env === 'development') return { label: 'DEVELOPMENT ENVIRONMENT', class: 'env-banner-development' };
        return null;
      });
      const performOidcValidation = async () => {
          // Initialize OIDC client
          const oidcClient = new Oidc.UserManager({
          // OIDC client configuration
          });
          try {
              // Check if there is no Laravel token and we need to perform OIDC validation
              if (!hasLaravelToken.value) {
                  // Get the OIDC user
                  const user = await oidcClient.getUser();
                  if (user && user.access_token) {
                      // Send the OIDC token to your Laravel API in the Authorization header
                      await axios.post(axios.defaults.baseURL + 'auth/oidc', {}, {
                          headers: { 'Authorization': `Bearer ${user.access_token}` }
                      });
                      // Store the Laravel token in local storage
                      localStorage.setItem('token', user.access_token);
                      hasLaravelToken.value = true;
                  }
              }
          }
          catch (error) {
              console.error('Error during OIDC validation:', error);
              showGlobalError('Error during OIDC validation.');
          }
      };
      onMounted(() => {
        registerErrorHandler((message) => {
          if (errorModal.value && typeof errorModal.value.show === 'function') {
            errorModal.value.show(message);
          } else {
            console.error('Error modal not ready:', message);
          }
        });
    });
      // Perform OIDC validation on component mount
      onMounted(() => {
          performOidcValidation();
      });
      onBeforeUnmount(() => {
        registerErrorHandler(null);
      });
      return {
          hasLaravelToken, errorModal, envBanner, apiUrl
      };
  },
  components: { Navigation, LoaderOverlay, GlobalErrorModal }
};
</script>


<style scoped>
.env-banner {
  width: 100%;
  text-align: center;
  font-weight: 700;
  font-size: 0.875rem;
  letter-spacing: 0.05em;
  padding: 0.375rem 0.75rem;
  z-index: 60;
}
.env-banner-staging {
  background-color: #f59e0b;
  color: #1f2937;
}
.env-banner-development {
  background-color: #10b981;
  color: #052e2b;
}
.backimg {
opacity: 0.30;
position: fixed; /* Changed from relative to fixed */
top: 0; /* Position it at the top of the viewport */
left: 0; /* Position it at the left of the viewport */
width: 100vw; /* Span the entire viewport width */
height: 100vh; /* Span the entire viewport height */
z-index: -1; /* Place it behind other content */
background: url('~@/assets/swirl_crop.jpg') no-repeat center center; /* Center the background */
background-color: #FFF;
background-size: cover; /* Cover the entire area of the div */
}

/* .backimg {
/* Existing styles
} */

.router-view-content {
min-height: calc(100vh - 64px); /* This assumes the nav bar is 64px tall */
width: 100%;
}

</style>